<template>
  <div class="my_body">
    <div class="heder_info">

      <img :src="$store.state.avatar" alt="">

      <div class="mytextinfo">
        <span style="font-weight: 500" class="username">{{this.$store.state.nickname}}</span>
        <span style="color: #999" class="mobile">{{shouji!=""?shouji:'暂未绑定'}}</span>
        <span style="font-size: 14px;color: #999999" class="address">
          <i class="iconfont icon-location-"></i>
          {{dizhi!=''?'暂无地址':dizhi}}
        </span>
      </div>
<!--      <img class="rightedi" src="/edit.png">-->
    </div>

    <div class="list">
        <div class="itme" @click="bangding">
          <img class="lefticon" src="/chongzhi.png">
          <span>绑定手机号码</span>
          <!--        <van-tag type="danger" style="font-size: 12px" size="medium">未绑定</van-tag>-->
          <span style="border-radius: 4px;background: #f0f0f0;padding: 0 3px;color: red">{{shouji!=""?'已绑定':'暂未绑定'}}</span>
          <img class="righticon" src="/rightjt.png" alt="">
        </div>
      <router-link :to="{path:'/account'}" tag="div">
        <div class="itme">
          <img class="lefticon" src="/yue.png">
          <span>我的账户</span>
          <span style="position: absolute;right: 40px">¥ {{jine}}</span>
          <img class="righticon" src="/rightjt.png" alt="">
        </div>
      </router-link>
    </div>

    <div style="width: 100%;height: 9px;background:#f8f8f8; "></div>

    <div class="list">

      <router-link :to="{path:'/Courses'}" tag="div">
        <div class="itme">
          <img class="lefticon" src="/querendingdan.png">
          <span>订单课程</span>
          <img class="righticon" src="/rightjt.png" alt="">
        </div>
      </router-link>
      <router-link :to="{path:'/couress'}" tag="div">
        <div class="itme">
          <img class="lefticon" src="/querendingdan.png">
          <span>组合订单</span>
          <img class="righticon" src="/rightjt.png" alt="">
        </div>
      </router-link>
      <router-link :to="{path:'/coupons'}" tag="div">
        <div class="itme">
          <img class="lefticon" src="/kabao.png">
          <span>我的卡劵</span>
          <img class="righticon" src="/rightjt.png" alt="">
        </div>
      </router-link>
      <div class="itme" @click="showPopup">
        <img class="lefticon" src="/tuijian.png">
        <span>向朋友推荐</span>
        <img class="righticon" src="/rightjt.png" alt="">
      </div>
      <router-link :to="{path:'/collection'}" tag="div">
        <div class="itme">
          <img class="lefticon" src="/shoucang.png">
          <span>我的收藏</span>
          <img class="righticon" src="/rightjt.png" alt="">
        </div>
      </router-link>
      <router-link :to="{path:'/My'}" tag="div">
        <div class="itme">

          <img class="lefticon" src="../assets/kf.png">
          <div style="width:100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
          <span>客服电话：400-181-9127</span>
          <dr/>
          <span>工作时间: 9:00-19:00</span>
          </div>
        </div>
      </router-link>
<!--      <div class="itme">-->
<!--        <img class="lefticon" src="/ziliao.png">-->
<!--        <span>学习资料包</span>-->
<!--        <img class="righticon" src="/rightjt.png" alt="">-->
<!--      </div>-->
<!--      <router-link :to="{path:'/comments'}" tag="div">-->
<!--        <div class="itme">-->
<!--          <img class="lefticon" src="/renwu.png">-->
<!--          <span>我的评论</span>-->
<!--          <img class="righticon" src="/rightjt.png" alt="">-->
<!--        </div>-->
<!--      </router-link>-->
<!--      <div>{{dizhi}}</div>-->
    </div>


<!--    <iframe id="geoPage" width=0 height=0 frameborder=0 style="display:none;" scrolling="no" src="https://apis.map.qq.com/tools/geolocation?key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp"></iframe>-->

    <van-popup  v-model="show"><img style="width: 100%;height: 100%;" src="http://qr.liantu.com/api.php?text=https://www.fuyueopera.com?recoid=1"/></van-popup>


  </div>
</template>

<script>
    import wx from 'weixin-js-sdk'
    export default {
        name: "My",
        data() {
            return {
                show: false,
                active: '0',
                touxiang:'',
                mingzi:'',
                dizhi:'',
                shouji:'',
                jine:'',
                morendizhi:''
            }
        },
        created() {
            this.getdata()
            // this.Tmap()
            console.log(this.$store.state.appid,21312)
        },
        mounted(){
            wx.updateAppMessageShareData({
                title: '悦戏小课堂', // 分享标题
                desc: '悦戏小课堂', // 分享描述
                link: 'https://www.fuyueopera.com', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://test.bergnet.cn/static/sy/icon1.png', // 分享图标
            })
        },
        methods:{

            showPopup() {
                this.show = true;
            },
            bangding(){
              if(this.shouji==""){
                  this.$router.push({ path:'/Mobile'})
              }

            },
            getdata() {
                this.myrequest({
                    url:'/client/getmyinfo.action',
                    types:'get',
                    data:{
                        // token:this.$store.state.token
                    },
                    succ: (res) => {

                        this.touxiang=res.data.avatar
                        console.log(res,213)
                        this.mingzi=res.data.nickname
                        this.dizhi=res.data.address
                        this.shouji=res.data.mobile
                        console.log(res.data.mobile,122)
                        this.jine=res.data.fee

                    },
                    errs: (msg) => {

                    }
                })
            },
        },

    }
</script>

<style scoped lang="stylus">
  .my_body {
    width: 100%;
    height 100vh
    background #f8f8f8
    >>>.van-popup--center{
      width 60%;
      height 200px;
    }

    .list {
      width 100%

      .itme {
        background #fff
        width 100%
        display flex
        position relative
        align-items center
        height 40px
        padding-left 10px
        border-bottom 1px solid #f5f5f5

        .lefticon {
          width 20px
          height 20px
        }

        span {
          margin-left 10px
          font-size 14px
        }

        .righticon {
          position absolute
          right 20px
          width 15px
          height 15px
        }
      }
    }

    .heder_info {
      background #fff
      width 100%
      display flex
      padding-left 10px;
      padding-top 20px
      padding-bottom 20px
      position relative
      border-bottom 10px solid #f8f8f8

      .rightedi {
        position absolute
        right 10px
        width 20px
        padding 20px
        height 20px
      }

      img {
        width 80px
        height 80px
        border-radius 4px
      }

      .mytextinfo {
        padding-left 10px
        display flex;
        flex-direction column
        justify-content center

        span:first-child {
          font-size 13pt
          font-weight 700 !important
        }
        span:nth-of-type(2) {
          font-size 10pt
          line-height 190%
        }
        span:nth-of-type(3) {
          font-size 10pt
        }

        span {
          font-size 16px
          color #4b4b4b
        }

        .address {
          img {
            width 15px;
            height 15px
          }
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/My.vue